const TALLY_BASE = "https://tally.so/r/LZ8RAj";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];
const UTM_STORE_KEY = "dp_utm";

(function captureUtms() {
    try {
        const params = new URLSearchParams(window.location.search);
        const found = {};
        let any = false;
        for (const key of UTM_KEYS) {
            const value = params.get(key);
            if (value) {
                found[key] = value;
                any = true;
            }
        }
        if (any) {
            const existing = JSON.parse(sessionStorage.getItem(UTM_STORE_KEY) || "{}");
            sessionStorage.setItem(UTM_STORE_KEY, JSON.stringify({ ...existing, ...found }));
        }
    } catch {
        /* storage unavailable — waitlist link still works */
    }
})();

export const WAITLIST_URL = (() => {
    try {
        const stored = JSON.parse(sessionStorage.getItem(UTM_STORE_KEY) || "{}");
        const url = new URL(TALLY_BASE);
        for (const key of UTM_KEYS) {
            if (stored[key]) url.searchParams.set(key, stored[key]);
        }
        return url.toString();
    } catch {
        return TALLY_BASE;
    }
})();
export const PRIVACY_URL = "/privacy";

export const CHAPTERS = [
    {
        num: "01",
        id: "chapter-01-profiles",
        title: "Profiles with context",
        copy: "Profiles give you enough context to understand why someone might actually be interesting to you — before you ever send a message.",
        note: "Mara is a fictional reference profile.",
        img: "/images/mara-meet.jpg",
        imgSm: "/images/mara-meet-sm.jpg",
        alt: "Meet Mara — a fictional example profile built around taste, obsessions and identity, showing her current obsession, interests and a glimpse of her world",
    },
    {
        num: "02",
        id: "chapter-02-obsession",
        title: "Current Obsession",
        copy: "Profiles change with people. A Current Obsession shows what's occupying someone's mind right now — and immediately gives others something to talk about.",
        note: "An established concept — the exact mechanics are still being explored.",
        img: "/images/mara-obsession.jpg",
        imgSm: "/images/mara-obsession-sm.jpg",
        alt: "Current Obsession concept visual — Mara's profile highlighting Everything Everywhere All at Once, the film occupying her attention right now",
    },
    {
        num: "03",
        id: "chapter-03-interests",
        title: "Interests that matter",
        copy: "Interests on Discovery aren't decorative tags. They are part of how people are discovered — especially when the things you care about are too specific for mainstream social apps.",
        img: "/images/mara-interests.jpg",
        imgSm: "/images/mara-interests-sm.jpg",
        alt: "Things I Can't Shut Up About concept visual — Mara's specific interests shown as signals for discovery, not decoration",
    },
    {
        num: "04",
        id: "chapter-04-3x3-lately",
        title: "3×3 Lately",
        copy: "Sometimes nine images communicate more than a bio. Representative collections could let people express taste, mood, culture and identity visually.",
        note: "One concept we're exploring — not a guaranteed final feature.",
        img: "/images/mara-3x3.jpg",
        imgSm: "/images/mara-3x3-sm.jpg",
        alt: "3×3 Lately concept visual — a nine-image grid expressing one person's recent moods, interests and moments",
    },
    {
        num: "05",
        id: "chapter-05-better-questions",
        title: "Better questions",
        copy: "Open-ended questions could reveal how someone thinks, what they value, and the details that might make two people curious about each other.",
        serif: "The goal is not to calculate a personality score. It is to create meaningful signals.",
        note: "A concept we're exploring — not a finished compatibility system.",
        img: "/images/mara-questions.jpg",
        imgSm: "/images/mara-questions-sm.jpg",
        alt: "Better Questions concept visual — Mara answering open-ended questions that surface specific, meaningful compatibility signals",
    },
    {
        num: "06",
        id: "chapter-06-start-from-context",
        title: "Start from context",
        copy: "First messages can connect directly to something on someone's profile — an obsession, a work, a question, a 3×3 item or another detail. Conversations shouldn't have to begin with \u201Chey\u201D.",
        img: "/images/mara-context.jpg",
        imgSm: "/images/mara-context-sm.jpg",
        alt: "Start from Context concept visual — a first message written in reply to a specific part of Mara's profile",
    },
];

export const scrollToId = (e, id) => {
    e.preventDefault();
    const el = document.querySelector(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
